import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './LandingLegalPage.css';
import messages from '../../locale/messages';
import Link from '../Link';

const SIDEBAR_LINKS = [
  { id: 'terms', to: '/privacy', label: messages.newLandingLegalSidebarTerms },
  { id: 'trust', to: '/safety', label: messages.newLandingFooterTrustSafety },
  { id: 'help', to: '/help', label: messages.newLandingFooterHelp },
];

class LandingLegalSidebar extends React.Component {
  static propTypes = {
    activePage: PropTypes.oneOf(['terms', 'trust', 'help']).isRequired,
  };

  render() {
    const { activePage } = this.props;

    return (
      <aside className={s.legalSidebar}>
        <div className={s.sidebarInner}>
          <h3>
            <FormattedMessage {...messages.newLandingLegalSidebarTitle} />
          </h3>
          <nav className={s.sidebarNav}>
            {SIDEBAR_LINKS.map(({ id, to, label }) => (
              <Link
                key={id}
                to={to}
                className={cx(activePage === id && s.active)}
              >
                <FormattedMessage {...label} />
              </Link>
            ))}
          </nav>
        </div>
      </aside>
    );
  }
}

export default withStyles(s)(LandingLegalSidebar);
